import React from 'react';
import { connect } from 'react-redux';
import flag from 'v2/helpers/flags';
import Section from 'v1/document-creator/components/template/docusign/Section';
import EnvelopeBox from './EnvelopeBox';

const SignatureSection = ({ meta, useSignature, status, clinkAccount, docType }) => {
  const showSection = docType === 'loi' || meta?.signatory;

  return showSection ? (
    <>
      <Section useSignature={useSignature} status={status} docType={docType} />
      {flag('FEATURES') && clinkAccount && meta?.signatory && (
        <EnvelopeBox info={clinkAccount} status={status} />
      )}
    </>
  ) : null;
};

const mapStateToProps = (state) => {
  return {
    clinkAccount: state.clinkAccount,
  };
};

export default connect(mapStateToProps)(SignatureSection);
